import '.bk{flex-shrink:0;}.ssr-plugin'
import '.bm{padding:1rem;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.bl{height:100%;}.ssr-plugin'
import '.b5{border:none;}.ssr-plugin'
import '.b6{background-color:transparent;}.ssr-plugin'
import '.fh{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.dc{position:sticky;}.ssr-plugin'
import '.fi{top:4rem;}.ssr-plugin'
import '.fj{z-index:7;}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.fk{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.fl{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a8{position:fixed;}.ssr-plugin'
import '.cd{top:0;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.fm{bottom:0px;}.ssr-plugin'
import '.er{z-index:9999;}.ssr-plugin'
import '.fn{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cv{justify-content:flex-end;}.ssr-plugin'
import '.bn{flex:1;}.ssr-plugin'
import '.al{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bk bm a2 bl b5 b6 fh"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ad"
    >
      <div className="dc fi fj ag fk v fl a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a8 cd bp bq fm er ag fn a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bm a cv fl"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bn al">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
